import { createSlice } from "@reduxjs/toolkit";
import { AccountStateType } from "./types";
import { trialPlanType } from "../../utils/constants";

export const initialState: AccountStateType = {
  isLoading: false,
  userDetails: null,
  userPhoneNumber: "",
  openResetPasswordModal: false,
  deleteUserLoader: false,
  planLists: [],
  isPlanLoading: false,
  selectPlanType: trialPlanType,
  selectPlanList: [],
  activePlan: {},
  currentPlan: {},
};

const account = createSlice({
  name: "accountState",
  initialState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setUserDetails(state, action) {
      const { token, isInvitedBySeat } = action.payload || {};

      const existingToken = localStorage.getItem("AccessToken");
      if (token && !existingToken) {
        localStorage.setItem("AccessToken", token);
      }

      const storedUser = localStorage.getItem("User");
      if (isInvitedBySeat && storedUser) {
        try {
          const currentUser = JSON.parse(storedUser);
          const updatedUser = { ...currentUser, isInvitedBySeat };
          localStorage.setItem("User", JSON.stringify(updatedUser));
        } catch (error) {
          console.error("Failed to parse stored user:", error);
        }
      }
      state.userDetails = action.payload;
    },
    setUserPhoneNumber(state, action) {
      state.userPhoneNumber = action.payload;
    },
    setOpenResetPasswordModal(state, action) {
      state.openResetPasswordModal = action.payload;
    },
    setPlanDetails(state, action) {
      state.planLists = action.payload;
    },
    setIsPlanLoading(state, action) {
      state.isPlanLoading = action.payload;
    },
    setDeleteUserLoader(state, action) {
      state.deleteUserLoader = action.payload;
    },
    setSelectPlanType(state, action) {
      state.selectPlanType = action.payload;
    },
    setSelectPlanList(state, action) {
      state.selectPlanList = action.payload;
    },
    setActivePlan(state, action) {
      state.activePlan = action.payload;
    },
    setCurrentPlan(state, action) {
      state.currentPlan = action.payload;
    },
    setUserCurrentTeam(state, action) {
      if (state.userDetails) {
        state.userDetails.currentTeamId = action.payload;
      }
    },

    setUserTeams(state, action) {
      if (state.userDetails) {
        state.userDetails.userTeams.push(action.payload);
      }
    },
    setUpdateUserTeams(state, action) {
      if (state.userDetails && Array.isArray(state.userDetails.userTeams)) {
        const updatedTeam = action.payload;
        const index = state.userDetails.userTeams.findIndex(
          (team) => team._id === updatedTeam._id
        );

        if (index !== -1) {
          // Update the existing team name
          state.userDetails.userTeams[index].name = updatedTeam.name;
        }
      }
    },
  },
});

export const {
  actions: AccountReducerAction,
  name: AccountReducerName,
  reducer: AccountReducer,
} = account;
